module.exports = __webpack_public_path__ + "img/title_txt_day1.145651a5.png";